import { useTranslation } from 'react-i18next';

export default function useRouteHistoryTableColumns() {
  const { t } = useTranslation(['table']);

  const columns = [
    {
      key: 'id_route',
      label: t('routes.history.route_number', { ns: 'table' }),
    },
    {
      key: 'price',
      label: t('routes.history.price', { ns: 'table' }),
    },
    {
      key: 'created_at',
      label: t('routes.history.created_at', { ns: 'table' }),
    },
  ];

  return { columns };
}
